import config from "@src/config";

export const authRefreshService = async (aws = {}) => {
  const request = await aws.sign(`${config.BASE_URL}auth-refresh`, {
    method: "GET",
  });

  return fetch(request).then(async (response) => {
    if (response.error) {
      throw new Error(response.error);
    }
    return await response.json();
  });
};

export default authRefreshService;
